module.exports = __webpack_public_path__ + "static/media/blog_img5.3ff53016.png";